export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */
  'guide.name': 'First Commonwealth',
  logout: 'Click to Logout',
  'nav.prev': 'Back',
  'nav.next': 'Next',
  'versus': 'VS',

  'title.default': 'First Commonwealth Client Guide',
  'title.guide': 'Welcome First Commonwealth Client Guide',
  'title.isCustomer':
    'Select Current Client Type First Commonwealth Client Guide',
  'title.summary':
    'Recommended Products & Services First Commonwealth Client Guide',

  'skipEmailWithLeadMsg': 'I prefer not to receive an email',

  'error.title': 'Error',
  'error.question.required': 'This question requires an answer',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.question.zipCode': 'Please enter a valid zip code',
  'error.question.postalCode': 'Please enter a valid zip code',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  'timeout.title': 'Reminder',
  'timeout.message':
    'It looks like you\'ve stepped away from your computer for a few minutes.  Please click "dismiss" to continue working.  Otherwise, the application will exit in {time}',
  'timeout.action': 'Dismiss',

  'sliderLabel.testing': 'testing the slider message',

  'form.submit': 'Send',

  'shareViaEmail.modal.title': 'Email Your Recommendations',
  'shareViaEmail.formBody': ' ',
  'shareViaEmail.formInput.emailAddress': 'Enter your email address:',
  'shareViaEmail.formInput.emailAddress.placeholder': ' ',
  'shareViaEmail.button': 'Send',
  'shareViaEmail.success.title': 'Email Sent',
  'shareViaEmail.success.message':
    'Your results have been sent to email you entered.',

  'shareViaSms.modal.title': 'Text Your Recommendations',
  'shareViaSms.formBody': ' ',
  'shareViaSms.formInput.phoneNumber': 'Enter your phone number:',
  'shareViaSms.formInput.phoneNumber.placeholder': ' ',
  'shareViaSms.button': 'Send',
  'shareViaSms.close': 'Close',
  'shareViaSms.success.title': 'Text Sent',
  'shareViaSms.success.message':
    'Your results have been sent to phone number you entered.',
  'shareViaSms.submitted': 'Your message has been successfully sent',

  'unsupportedBrowser.title': 'Your browser is out of date',
  'unsupportedBrowser.message':
    'Please get the new <href>https://www.microsoft.com/en-us/edge||Microsoft Edge</href>',

  'completeGuide.title': 'Contact Information',
  'completeGuide.subtitle':
    'To save your selected recommendations, please provide your contact information.',
  'completeGuide.reviewProducts': 'Selected Products',
  'completeGuide.reviewProducts.info':
    'Review your list selected products below and make sure that you did not forget to add any items:',
  'completeGuide.submitForm': 'Complete The Conversation',
  'completeGuide.noProductsInCart': 'Your cart is empty.',

  'contactMe.title': 'Contact Information',
  'contactMe.subtitle': 'Please enter your contact information:',
  'contactMeForm.formInput.phone': 'Phone Number (optional)',
  'contactMeForm.formInput.phone.error.validate': 'Please enter a valid number',
  'contactMeForm.formInput.customerId': 'CIF Number',
  'contactMeForm.formInput.customerId.placeholder': 'CIF Number',
  'contactMeForm.formInput.email.error.pattern': 'Please enter a valid email',
  'contactMeForm.formInput.email.error.maxLength': 'Max of 100 characters allowed',
  'contactMeForm.formInput.customerId.error.maxLength': 'Max of 100 characters allowed',
  'contactMeForm.formInput.firstName.error.maxLength': 'Max of 100 characters allowed',
  'contactMeForm.formInput.lastName.error.maxLength': 'Max of 100 characters allowed',
  'contactMeForm.formInput.email.placeholder': 'Customer@email.com',
  'contactMe.disclosure':
    'By submitting your contact information you are permitting us to send you an email with a link to your saved recommendations and giving us permission to contact you.',
  'contactMe.popup':
    'Make sure any pop-up blockers are disabled before submitting form.',
  'contactMe.success.title': 'Email Sent',
  'contactMe.success.message': 'Results have been sent to email you entered.',

  'contactMeConfirmation.title': 'Contact Sent',
  'contactMeConfirmation.submitted': 'Your contact information has been sent.',
  'contactMeConfirmation.close': 'Dismiss',

  'contactFormModal.header': 'Thank You!',
  'contactFormModal.description':
    'Pick a location on the next screen to schedule your appointment.',
  'contactFormModal.footer':
    'You’ll receive an email with your Product Recommendations!',
  'contactFormModal.button': 'OK',

  pleaseSelect: 'Please Select',

  'landing.title': 'Welcome to the party, my friend.',
  'landing.welcome': 'Welcome',
  'landing.title': "We're so glad you're here today!",
  'landing.subtitle': "I'm excited to spend a few minutes going through our interactive guide together.",
  'landing.description1': "We'll talk about your financial goals and I'll ask questions focused on improving your financial life. Then I'll share a personalized recommendations with you.",
  'landing.description2': "Goals can change, so I look forward to doing this again in the future.",
  'landing.getStarted': "Let's get started",

  'products.disclosures': 'Disclosures',
  'products.disclosure': 'Disclosure',
  'product.learnMore': 'Learn More',
  'product.featureHeader': "Why it's right for you",
  'product.cta.open': "Open Online",
  'product.cta.apply': "Apply Online",
  'product.cta.contact': "Contact Me",
  'product.cta.schedule': "Make an Appointment",

  'footer.copyright':
    'First Commonwealth Bank, Member FDIC and Equal Housing Lender',
  'footer.copyrightTwo':
    'All loans and accounts subject to credit approval. Terms and conditions apply.',

  'contactFormSubmitted.success.title': 'Form submitted',
  'contactFormSubmitted.success.message':
    'Your conversation and product recommendations have successfully been sent.',

  'summary.back': 'Back to Guide',
  'summary.complete': 'Complete Guide',
  'summary.completeConsumerOnline': 'Contact Me',
  'summary.yourAnswers': 'Your Survey Answers',
  'summary.addToCart': 'Select {name}',
  'summary.removeFromCart': 'Remove {name}',
  'summary.recommendations.title': 'Recommendations',
  'summary.recommendations.subtitle':
    'We have some suggestions that we think will be good for you.',
  'summary.features': 'Why this product?',
  'summary.actions.print': 'Print my recommendations',
  'summary.actions.email': 'Email',
  'summary.actions.answersTitle': 'We recommend these products:',
  'summary.actions.answers': 'See your answers',
  'summary.existingProduct': 'Congratulations, you are in the correct product',
  'summary.cta': 'Apply Online',
  'summary.recommendations.footer':'All loans and accounts subject to credit approval.<br>Terms and conditions apply.',

  'employeeLogin.title': 'First Commonwealth',
  'employeeLogin.edit.header': 'Login',
  'employeeLogin.edit.subtitle':
    "Enter your information and select the financial centers for your account. When you are finished, click the 'Save & Continue' button.",
  'employeeLogin.branches.search.label': 'Search for financial centers:',
  'employeeLogin.branches.search.help':
    'Results from the financial centers search will be shown here.',
  'employeeLogin.branches.search.empty':
    'No financial centers were found. Please try another search.',
  'employeeLogin.branches.assigned': 'Associated Financial Centers:',
  'employeeLogin.branches.assigned.help':
    "No financial centers are associated with this profile. Use the 'search for financial centers' section above to search and add locations.",
  'employeeLogin.branches.assigned.error':
    'At least one financial center association is required.',
  'employeeLogin.login.subtitle':
    "You are almost ready. Confirm your account details, select your financial center location, and click the 'Login' button.",
  'employeeLogin.login.branchList':
    'Select which financial center you would like to log in with:',
  'employeeLogin.login.branchList.alert':
    'You must select a financial center before you log in.',
  'employeeLogin.flowStep.branch': 'Select a financial center',

  /**
   * ============================
   * CONSUMER PRODUCT MESSAGES
   * ============================
   */
  '22000.name': 'Hometown Checking',
  '22000.description': 'A simple account for everyone.',
  '22000.description.abbreviated': 'A simple account for everyone.',
  '22000.features.count': 5,
  '22000.features.1':
    '<b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22000.features.2':
    '<b>Qualify for lower loan rates</b> with a rate discount on your First Commonwealth home equity loan or personal loan when you setup automatic payments from your First Commonwealth checking account',
  '22000.features.3':
    '<b>Mobile and Online Banking</b> provide tools and services to manage your money and build financial confidence',
  '22000.features.4':
    'No monthly deposit or balance requirements',
  '22000.features.5':
    '$2 monthly service charge is waived with eStatement enrollment',
  '22000.url': 'https://www.fcbanking.com/personal/checking-accounts/',
  '22000.cta.1': 'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22000.disclosures.count': 0,

  '22001.name': 'Hometown Checking Plus',
  '22001.description': 'An account that pays interest plus more great benefits.',
  '22001.description.abbreviated': 'An account that pays interest plus more great benefits.',
  '22001.features.count': 5,
  '22001.features.1':
    '<b>Earn interest</b> with competitive, tiered interest rates applied to your balance',
  '22001.features.2':
    '<b>Fee-free ATM access:</b>' +
    '<ul>' +
    '  <li>55,000+ ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance></li>' +
    '  <li>Plus 5 non-network ATM withdrawal fees waived per month¹</li>' +
    '</ul>',
  '22001.features.3':
    '<b>Qualify for lower loan rates</b> with a rate discount on your First Commonwealth home equity loan or personal loan when you setup automatic payments from your First Commonwealth checking account',
  '22001.features.4':
    '<b>Mobile and Online Banking</b> provide tools and services to manage your money and build financial confidence',
  '22001.features.5':
    'We will waive the $10 monthly service charge with one of the following:' +
    '<ul>' +
    '  <li>Monthly deposits totaling $1,000+ OR </li>' +
    '  <li>Daily deposit relationship balances² totaling $5,000+</li>' +
    '</ul>',
  '22001.url': 'https://www.fcbanking.com/personal/checking-accounts/',
  '22001.cta.1': 'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22001.disclosures.count': 2,
  '22001.disclosures.1':
    '¹You will be responsible for any additional fees charged by the owner of a non-network ATM as well as any international transaction or other fees charged by the network.',
  '22001.disclosures.2':
    '²Includes another checking, savings, money market account or club account that shares a primary or joint owner with the Hometown Checking Plus account.',

  '22002.name': 'Hometown Checking Premium',
  '22002.description':
    'An account that pays interest and provides premium solutions.',
  '22002.description.abbreviated':
    'An account that pays interest and provides premium solutions.',
  '22002.features.count': 5,
  '22002.features.1':
    'Premium benefits unique to this account:' +
    '<ul>' +
    '  <li><b>Qualify for higher relationship interest rates</b> on a Relationship Money Market account</li>' +
    '  <li><b>Free overdraft protection</b> available from any of your linked First Commonwealth accounts, including lines of credit</li>' +
    '  <li><b>Premium debit card benefits</b> with the World Debit™ Mastercard<sup>®</sup> Debit Card</li>' +
    '  <li><b>Billpay discount:</b>  Receive a 25% discount on rush bill payments </li>' +
    '  <li><b>Annual Fee Waiver on Brokerage IRAs</b></li>' +
    '  <li><b>All non-network ATM fees are waived</b>, including cash withdrawals, deposits, transfers and inquiries¹</li>' +
    '</ul>',
  '22002.features.2':
    '<b>Plus Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22002.features.3':
    '<b>Qualify for lower loan rates</b> with a rate discount on your First Commonwealth home equity loan or personal loan when you setup automatic payments from your First Commonwealth checking account',
  '22002.features.4':
    '<b>Earn interest</b> with competitive, tiered interest rates applied to your balance',
  '22002.features.5':
    'We will waive the $15 monthly service charge with one of the following:' +
    '<ul>' +
    '  <li>Monthly deposits totaling $2,000+ OR </li>' +
    '  <li>Daily deposit relationship balances² totaling $10,000+, OR</li>' +
    '  <li>Active Military or Veteran ID</li>' +
    '</ul>',
  '22002.url': 'https://www.fcbanking.com/personal/checking-accounts/',
  '22002.cta.1': 'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22002.disclosures.count': 2,
  '22002.disclosures.1':
    '¹You will be responsible for any additional fees charged by the owner of a non-network ATM as well as any international transaction or other fees charged by the network.',
  '22002.disclosures.2':
    '²Includes another checking, savings, money market account or club account that shares a primary or joint owner with the Hometown Checking Premium account.',

  '22003.name': 'SmartPay Card',
  '22003.description':
    'A checkless account that provides peace of mind. You can only spend the money you have, which means no overdraft fees ever.',
  '22003.description.abbreviated':
    'A checkless account that provides peace of mind. You can only spend the money you have, which means no overdraft fees ever.',
  '22003.features.count': 7,
  '22003.features.1': 'No overdraft fees ever',
  '22003.features.2': 'No monthly deposit or balance requirements',
  '22003.features.3':
    'Certified as meeting the Bank On National Account Standards for safe and affordable accounts',
  '22003.features.4':
    'Easy payment options including Zelle for person to person payments and online bill payment',
  '22003.features.5':
    'Deposit checks, set up transfers and pay bills using our mobile app',
  '22003.features.6':
    'Surcharge-free access to over 55,000 ATMs through Allpoint and Freedom Alliance',
  '22003.features.7': 'Low $5 monthly service charge',
  '22003.url':
  'https://www.fcbanking.com/personal/checking-accounts/smartpay-card/',
  '22003.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22003.disclosures.count': 0,

  '22004.name': 'Confidence Checking',
  '22004.description':
    'An eco-friendly account that can help you feel confident in your finances and your impact on the environment. You can only spend the money you have, which means no overdraft fees ever.',
  '22004.description.abbreviated':
    'An eco-friendly account that can help you feel confident in your finances and your impact on the environment. You can only spend the money you have, which means no overdraft fees ever.',
  '22004.features.count': 4,
  '22004.features.1':
    '<b>Bank with confidence</b>' +
    '<ul>' +
    '  <li><b>No overdraft fees ever</b></li>' +
    '  <li>No opening deposit required</li>' +
    '  <li>No monthly deposit or balance requirements</li>' +
    '  <li><b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance></li>' +
    '  <li><b>Mobile and Online Banking</b> provide tools and services to manage your money and build financial confidence</li>' +
    '</ul>',
  '22004.features.2':
    '<b>Eco-friendly</b>' +
    '<ul>' +
    '  <li>Mastercard<sup>®</sup> debit card made from ocean-bound plastic</li>' +
    '  <li>No paper checks allowed</li>' +
    '  <li>Enroll in eStatements</li>' +
    '</ul>',
  '22004.features.3':
    '<b>Qualify for lower loan rates</b> with a rate discount on your First Commonwealth home equity loan or personal loan when you setup automatic payments from your First Commonwealth checking account',
  '22004.features.4':
    'We will waive the $5 monthly service charge when you complete 5 or more customer initiated transactions during the statement cycle (transactions will be counted on the date that they post and clear the account)',
  '22004.url':
  'https://www.fcbanking.com/personal/checking-accounts/confidence-checking/',
  '22004.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22004.disclosures.count': 0,

  '22074.name': 'ClickSWITCH',
  '22074.description':
    'Easily switch your direct deposit and ACH payments to your new checking account using our ClickSWITCH tool.',
  '22074.description.abbreviated':
    'Easily switch your direct deposit and ACH payments to your new checking account using our ClickSWITCH tool.',
  '22074.features.count': 3,
  '22074.features.1':
    'This fast, secure and free tool makes it easy to switch your direct deposits, including Social Security payments',
  '22074.features.2':
    'Move your recurring payments from your old bank in just a few clicks',
  '22074.features.3':
    'Send an account closure letter through the system to save you a call or trip to the bank to close your previous account',
  '22074.disclosures.count': 0,
  '22074.url': 'https://www.fcbanking.com/personal/checking-accounts/switch-kit/',

  '22010.name': 'Hometown Savings',
  '22010.description':
    'A free savings account that can also provide free overdraft protection when linked to any of the Hometown Checking accounts.',
  '22010.description.abbreviated':
    'A free savings account that can also provide free overdraft protection when linked to any of the Hometown Checking accounts.',
  '22010.features.count': 5,
  '22010.features.1':
    '<b>Peace of mind</b> with free overdraft protection on any linked Hometown Checking account',
  '22010.features.2':
    '<b>No monthly fees</b> and no monthly deposit or balance requirements',
  '22010.features.3':
    '<b>Increase your savings</b> with competitive, tiered interest rates applied to your balance',
  '22010.features.4':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22010.features.5':
    '<b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22010.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/',
  '22010.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22010.disclosures.count': 0,

  '22011.name': 'American Dream Savings',
  '22011.description':
    'Get rewarded with higher interest rates based on your banking relationship.',
  '22011.description.abbreviated':
    'Get rewarded with higher interest rates based on your banking relationship.',
  '22011.features.count': 4,
  '22011.features.1':
    '<b>Earn higher interest rates</b> when additional accounts within the following product groupings are included in the Relationship:' +
    '<ul>' +
    '  <li>Checking Account or Money Market Account</li>' +
    '  <li>Certificate of Deposit or Individual Retirement Account</li>' +
    '  <li>Consumer Loan (Installment, Home Equity, Personal Line of Credit, Mortgage or Time and Demand)</li>' +
    '</ol>' +
    'Multiple accounts within the same product grouping will count as only one',
  '22011.features.2':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22011.features.3':
    '<b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22011.features.4':
    'Your daily balance of $100 or more will waive the $2 monthly service charge',
  '22011.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/',
  '22011.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22011.disclosures.count': 0,

  '22012.name': 'Hometown Money Market',
  '22012.description':
    'Earn higher interest for higher balances with easy access to your money.',
  '22012.description.abbreviated':
    'Earn higher interest for higher balances with easy access to your money.',
  '22012.features.count': 5,
  '22012.features.1':
    '<b>Increase your savings</b> with competitive, tiered interest rates applied to your balance',
  '22012.features.2':
    '<b>Check writing</b> is permitted for easy access to your money',
  '22012.features.3':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22012.features.4':
    '<b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22012.features.5':
    'Your daily balance of $1,000 or more will waive the $3 monthly service charge',
  '22012.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/',
  '22012.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22012.disclosures.count': 0,

  '22013.name': 'Relationship Money Market',
  '22013.description':
    'Qualify for higher Relationship Rates if you have our Hometown Checking Premium account.',
  '22013.description.abbreviated':
    'Qualify for higher Relationship Rates if you have our Hometown Checking Premium account.',
  '22013.features.count': 5,
  '22013.features.1':
    '<b>Earn relationship interest rates</b> on your Relationship Money Market when you also have a Hometown Checking Premium account',
  '22013.features.2':
    '<b>Check writing</b> is permitted for easy access to your money',
  '22013.features.3':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22013.features.4':
    '<b>Fee-free access</b> to over 55,000 ATMs through <feature_allpointAndFreedomAlliance>Allpointᵀᴹ and Freedom Allianceᵀᴹ</feature_allpointAndFreedomAlliance>',
  '22013.features.5':
    'Your daily balance of $1,000 or more will waive the $3 monthly service charge',
  '22013.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/',
  '22013.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22013.disclosures.count': 0,

  '22020.name': 'Tower Savers Kids Savings',
  '22020.description':
    'This account is a great way to start saving for your child’s future and help them build good saving habits.',
  '22020.description.abbreviated':
    'This account is a great way to start saving for your child’s future and help them build good saving habits.',
  '22020.features.count': 5,
  '22020.features.1':
    '<b>Earn interest</b> and watch your money grow with tiered interest rates',
  '22020.features.2':
    '<b>No monthly service charges</b> through age 21',
  '22020.features.3':
    '<b>Parent/guardian can monitor account</b> by linking your account to the child savings account so you can see everything in online banking',
  '22020.features.4':
    '<b>Saving is easy</b> when you set up direct deposit and automatic transfers to help build the savings',
  '22020.features.5':
    '<b>Learn good financial habits</b> with access to <feature_5_22020>online resources</feature_5_22020>',
  '22020.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/tower-savers-child-savings-account/',
  '22020.cta.1':
    'https://fcbanking.loanspq.com/Apply.aspx?lenderref=FCB_120419&list=1s',
  '22020.disclosures.count': 0,

  '22021.name': 'Vacation Club Account',
  '22021.description':
    'Save year-round for a dream vacation getaway and earn interest to grow your balance even faster.',
  '22021.description.abbreviated':
    'Save year-round for a dream vacation getaway and earn interest to grow your balance even faster.',
  '22021.features.count': 3,
  '22021.features.1':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22021.features.2':
    '<b>Earn competitive interest</b> on your balance, which will be credited on your disbursement date.',
  '22021.features.3':
    '<b>Removes the temptation</b> to spend the money you are saving' +
    '<ul>' +
    '  <li>The funds will be released on your annual disbursement date, which is May 25 or an alternative disbursement date you can choose at account opening</li>' +
    '  <li>You can choose to receive your annual payout by check or via a direct transfer into another First Commonwealth Bank account</li>' +
    '</ul>',
  '22021.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/holiday-and-vacation-clubs/',
  '22021.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22021.disclosures.count': 0,

  '22022.name': 'Holiday Club Account',
  '22022.description':
    'Save year-round for your holiday shopping and earn interest on your balance.',
  '22022.description.abbreviated':
    'Save year-round for your holiday shopping and earn interest on your balance.',
  '22022.features.count': 3,
  '22022.features.1':
    '<b>Saving is easy</b> when you deposit checks and set up transfers using our mobile app',
  '22022.features.2':
    '<b>Earn competitive interest</b> on your balance, which will be credited on your disbursement date.',
  '22022.features.3':
    '<b>Removes the temptation</b> to spend the money you are saving' +
    '<ul>' +
    '  <li>The funds will be released on your annual disbursement date, which is October 15 or an alternative disbursement date you can choose at account opening</li>' +
    '  <li>You can choose to receive your annual payout by check or via a direct transfer into another First Commonwealth Bank account</li>' +
    '</ul>',
  '22022.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/holiday-and-vacation-clubs/',
  '22022.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22022.disclosures.count': 0,

  '22023.name': 'Health Savings Account (HSA)',
  '22023.description':
    'This account is used to pay for qualified medical expenses and offers tax benefits.',
  '22023.description.abbreviated':
    'This account is used to pay for qualified medical expenses and offers tax benefits.',
  '22023.features.count': 4,
  '22023.features.1':
    '<b>Tax deductions:</b> You can deduct all contributions to your Health Savings Account (HSA) on your taxes, with the exception of any money added to your account by an employer or from your IRA',
  '22023.features.2':
    '<b>Tax-free withdrawals:</b> Withdrawals from your account may be made tax-free to pay for qualified medical expenses, including vision and dental',
  '22023.features.3':
    '<b>Tax-free interest:</b> Earn tax-free interest on the money in your HSA',
  '22023.features.4':
    '<b>Use now or save for later:</b> The money in your HSA rolls over each year and accumulates if it\'s not spent',
  '22023.url':
    'https://www.fcbanking.com/personal/checking-accounts/health-savings-account/',
  '22023.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22023.disclosures.count': 0,

  '22024.name': 'CD',
  '22024.description':
    'CDs are the perfect way to invest and grow your money without losing sleep over the negative effects of up and down markets.',
  '22024.description.abbreviated':
    'CDs are the perfect way to invest and grow your money without losing sleep over the negative effects of up and down markets.',
  '22024.features.count': 4,
  '22024.features.1':
    '<b>Protect your money</b> with the security of FDIC insurance up to the maximum limits',
  '22024.features.2':
    '<b>Peace of mind</b> knowing exactly how much money you’ll earn with fixed terms from 90 days to 60 months and fixed interest rates',
  '22024.features.3':
    '<b>Earn more</b> by redepositing your interest into your CD, or transfer it to an FCB checking or savings account each month',
  '22024.features.4':
    'Minimum Balance Requirements:' +
    '<ul>' +
    '  <li>$2,500 for CDs with terms less than 12 months</li>' +
    '  <li>$500 for CDs with terms 12 months or greater</li>' +
    '</ul>',
  '22024.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/certificates-of-deposit-cds/',
  '22024.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22024.disclosures.count': 0,

  '22025.name': 'Traditional or Roth IRAs',
  '22025.description':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Traditional IRA CD is a tax-deferred Certificate of Deposit account that provides the benefits of a Traditional IRA (tax-deductible contributions, tax-deferred growth, FDIC insurance, etc. ) and a CD account (fixed rate of interest, higher returns, set maturity date, etc.).',
  '22025.description.abbreviated':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Traditional IRA CD is a tax-deferred Certificate of Deposit account that provides the benefits of a Traditional IRA (tax-deductible contributions, tax-deferred growth, FDIC insurance, etc. ) and a CD account (fixed rate of interest, higher returns, set maturity date, etc.).',
  '22025.features.count': 1,
  '22025.features.1':
    'Deciding between a Traditional or Roth IRA and IRA CD or IRA Savings is important. Please consult with your tax advisor to determine the plan that best fits your future.',
  '22025.features.table.count': 2,
  '22025.features.table.1': ['22026', '22028'],
  '22025.features.table.2': ['22025', '22027'],
  '22025.features.table.name': 'IRA Certificate of Deposit (CD)',
  '22025.features.table.content.count': 2,
  '22025.features.table.content.1': 'Fixed rate of interest',
  '22025.features.table.content.2': 'Set maturity date',
  '22025.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/individual-retirement-accounts-iras/',
  '22025.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22025.disclosures.count': 0,

  '22026.name': 'Traditional IRA Savings',
  '22026.description':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Traditional IRA Savings account is a tax-deferred account that provides the benefits of a Traditional IRA (tax-deductible contributions, tax-deferred growth, FDIC insurance, etc.) and an IRA Savings account (low minimum deposit, no bank early withdrawal penalty, no maturity date, variable rate of interest, etc.).',
  '22026.description.abbreviated':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Traditional IRA Savings account is a tax-deferred account that provides the benefits of a Traditional IRA (tax-deductible contributions, tax-deferred growth, FDIC insurance, etc.) and an IRA Savings account (low minimum deposit, no bank early withdrawal penalty, no maturity date, variable rate of interest, etc.).',
  '22026.features.count': 9,
  '22026.features.1':
    'With a low minimum balance to open and no bank early withdrawal penalty, the IRA Savings account offers benefits perfect for someone who is just starting to think about retirement or someone who may be looking for an alternative to the IRA CD.',
  '22026.features.2':
    'An IRA Savings account is a flexible way to build up funds without sacrificing access to your money',
  '22026.features.3': 'You can contribute at any age if you have earned income',
  '22026.features.4':
    'Your annual contribution limits are set by the IRS and include a catch up amount for those age 50 and older',
  '22026.features.5':
    'All contributions may be fully or partially deductible based on your tax filing status and income',
  '22026.features.6':
    'You’ll save on taxes now, but pay later when you make required withdrawals',
  '22026.features.7':
    'Required Minimum Distributions (RMD) must begin at age 73',
  '22026.features.8':
    'Additional contributions of at least $25 may be made at any time, up to your annual maximum eligibility amount',
  '22026.features.9':
    'IRA deposits are insured separately from other deposit accounts for FDIC insurance coverage, up to $250,000 for all IRAs owned by the same person at the same bank.',
  '22026.features.table.count': 2,
  '22026.features.table.1': ['22026', '22028'],
  '22026.features.table.2': ['22025', '22027'],
  '22026.features.table.name': 'Traditional IRA',
  '22026.features.table.content.count': 4,
  '22026.features.table.content.1': 'Tax-deductible contributions',
  '22026.features.table.content.2': 'Tax-deferred growth',
  '22026.features.table.content.3': 'Required minimum distributions begin at age 73',
  '22026.features.table.content.4': 'No contribution age limits (no IRS income ceiling)',
  '22026.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/individual-retirement-accounts-iras/',
  '22026.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22026.disclosures.count': 0,

  '22027.name': 'Roth IRA CD',
  '22027.description':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Roth IRA CD is a tax-exempt Certificate of Deposit account that provides the benefits of a Roth IRA (no contribution age limits, tax-free growth, no required minimum distributions, etc.) and a CD account (fixed rate of interest, higher returns, set maturity date, etc.).',
  '22027.description.abbreviated':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Roth IRA CD is a tax-exempt Certificate of Deposit account that provides the benefits of a Roth IRA (no contribution age limits, tax-free growth, no required minimum distributions, etc.) and a CD account (fixed rate of interest, higher returns, set maturity date, etc.).',
  '22027.features.count': 7,
  '22027.features.1':
    'You’ll pay taxes on your contributions now, but enjoy tax-free qualified withdrawals later',
  '22027.features.2': 'Contributions are never tax-deductible',
  '22027.features.3':
    'You can contribute at any age if you have earned income below the IRS threshold',
  '22027.features.4':
    'Your annual contribution limits are set by the IRS and include a catch up amount for those age 50 and older',
  '22027.features.5': 'There is no mandatory distribution at any age',
  '22027.features.6':
    'Watch your investment grow with a fixed rate of interest for the duration of the term<ul><li>Note: Any additional deposits may only be made during the 10-day grace period following the maturity date</li></ul>',
  '22027.features.7':
    'IRA deposits are insured separately from other deposit accounts for FDIC insurance coverage, up to $250,000 for all IRAs owned by the same person at the same bank.',
  '22027.features.table.count': 2,
  '22027.features.table.1': ['22026', '22028'],
  '22027.features.table.2': ['22025', '22027'],
  '22027.features.table.content.count': 4,
  '22027.features.table.name': 'IRA Savings',
  '22027.features.table.content.1': 'Variable rate of interest',
  '22027.features.table.content.2': 'No maturity date',
  '22027.features.table.content.3': 'No bank early withdrawal penalty',
  '22027.features.table.content.4': 'Low minimum deposit and contribution amounts ($25)',
  '22027.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/individual-retirement-accounts-iras/',
  '22027.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22027.disclosures.count': 0,

  '22028.name': 'Roth IRA Savings',
  '22028.description':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Roth IRA Savings is a tax-exempt IRA Savings account that provides the benefits of a Roth IRA (no contribution age limits, tax-free growth, no required minimum distributions, etc.) and an IRA Savings account (low minimum deposit, no bank early withdrawal penalty, no maturity date, variable rate of interest, etc.).',
  '22028.description.abbreviated':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantage way. A Roth IRA Savings is a tax-exempt IRA Savings account that provides the benefits of a Roth IRA (no contribution age limits, tax-free growth, no required minimum distributions, etc.) and an IRA Savings account (low minimum deposit, no bank early withdrawal penalty, no maturity date, variable rate of interest, etc.).',
  '22028.features.count': 9,
  '22028.features.1':
    'With low minimum balance to open and no bank early withdrawal penalty, the IRA Savings account offers benefits perfect for someone who is just starting to think about retirement or someone who may be looking for an alternative to the IRA CD.',
  '22028.features.2':
    'An IRA Savings account is a flexible way to build up funds without sacrificing access to your money',
  '22028.features.3': 'Contributions are never tax-deductible',
  '22028.features.4':
    'You can contribute at any age if you have earned income below the IRS threshold',
  '22028.features.5':
    'Your annual contribution limits are set by the IRS and include a catch up amount for those age 50 and older',
  '22028.features.6':
    'You’ll pay taxes on your contributions now, but enjoy tax-free qualified withdrawals later',
  '22028.features.7': 'There is no mandatory distribution at any age',
  '22028.features.8':
    'Additional contributions of at least $25 may be made at any time, up to your annual maximum eligibility amount',
  '22028.features.9':
    'IRA deposits are insured separately from other deposit accounts for FDIC insurance coverage, up to $250,000 for all IRAs owned by the same person at the same bank.',
  '22028.features.table.count': 2,
  '22028.features.table.1': ['22026', '22028'],
  '22028.features.table.2': ['22025', '22027'],
  '22028.features.table.name': 'Roth IRA',
  '22028.features.table.content.count': 4,
  '22028.features.table.content.1': 'Contributions are not tax-deductible',
  '22028.features.table.content.2': 'Tax-free growth',
  '22028.features.table.content.3': 'No required minimum distributions',
  '22028.features.table.content.4': 'No contribution age limits (IRA income ceiling applies)',
  '22028.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/individual-retirement-accounts-iras/',
  '22028.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22028.disclosures.count': 0,

  '22029.name': 'Coverdell Education Savings Account',
  '22029.description':
    'A great way to save for college or other educational expenses.',
  '22029.description.abbreviated':
    'A great way to save for college or other educational expenses.',
  '22029.features.count': 4,
  '22029.features.1':
    '<b>Tax-free distributions:</b> Receive tax-free distributions to pay for qualified education expenses',
  '22029.features.2':
    '<b>Use now or save for later:</b> Use the funds in a Coverdell Education Savings Account (CESA) for qualified K-12 and secondary education expenses',
  '22029.features.3':
    '<b>Earn interest:</b> The account balance grows through deposits and interest',
  '22029.features.4':
    '<b>Contributions:</b> Anyone can make a contribution to the account up to the $2,000 yearly maximum',
  '22029.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/coverdell-education-savings-accounts/',
  '22029.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22029.disclosures.count': 0,

  '22030.name': 'Talk with a Financial Professional',
  '22030.description':
    'Advice on helping you build a bright future through investments, retirement planning, and life insurance',
  '22030.description.abbreviated':
    'Advice on helping you build a bright future through investments, retirement planning, and life insurance',
  '22030.features.count': 4,
  '22030.features.1':
    '<b>Build financial confidence</b> with access to financial professionals who will guide you and answer your questions',
  '22030.features.2':
    '<b>Earn more</b> by exploring saving and investing options with a potentially higher rate of return',
  '22030.features.3':
    '<b>Peace of mind</b> that you’re on the right track to retire confidently and comfortably',
  '22030.features.4':
    '<b>Helpful tools</b> to see how your money works with a Money Guide Pro plan',
  '22030.url':
    'https://www.fcbanking.com/personal/investment-brokerage-services/',
  '22030.cta.1':
    'https://fcbanking.castlecustomerconnect.com/ ',
  '22030.disclosures.count': 0,

  '22031.name': 'Hometown Savings',
  '22031.description':
    'A no-fee savings account that can also provide free overdraft protection when linked to any of the Hometown Checking accounts',
  '22031.description.abbreviated':
    'A no-fee savings account that can also provide free overdraft protection when linked to any of the Hometown Checking accounts',
  '22031.features.count': 5,
  '22031.features.1':
    'Provides free overdraft protection on any linked Hometown Checking account',
  '22031.features.2': 'No monthly deposit or balance requirements',
  '22031.features.3':
    'Competitive, tiered interest rates applied to your balance',
  '22031.features.4':
    'Deposit checks and set up transfers using our mobile app',
  '22031.features.5':
    'Surcharge-free access to over 55,000 ATMs through Allpoint and Freedom Alliance',
  '22031.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/',
  '22031.cta.1':
    'https://fcbanking.loanspq.com/xa/xpressApp.aspx?lenderref=FCB_120419&type=1',
  '22031.disclosures.count': 0,

  '22032.name': 'Traditional or Roth IRA',
  '22032.description':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantaged way. Deciding between a Traditional or Roth IRA and IRA CD or IRA Savings is important. Please consult with your tax advisor to determine the plan that best fits your future.',
  '22032.description.abbreviated':
    'An Individual Retirement Account (IRA) allows you to save money for retirement in a tax-advantaged way. Deciding between a Traditional or Roth IRA and IRA CD or IRA Savings is important. Please consult with your tax advisor to determine the plan that best fits your future.',
  '22032.features.table.count': 2,
  '22032.features.table.1': ['22026', '22028'],
  '22032.features.table.2': ['22025', '22027'],
  '22032.url':
    'https://www.fcbanking.com/personal/savings-and-money-market-accounts/individual-retirement-accounts-iras/',
  '22032.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22032.disclosures.count': 0,

  '22050.name': 'Mortgage',
  '22050.description':
    'Finding the right home isn’t always easy. Fortunately, finding the right mortgage loan with a competitive rate that works for your budget and needs can be.  A Mortgage Loan Officer will help guide you through the mortgage basics and the not-so-basics to determine the best option for you.',
  '22050.description.abbreviated':
    'Finding the right home isn’t always easy. Fortunately, finding the right mortgage loan with a competitive rate that works for your budget and needs can be.  A Mortgage Loan Officer will help guide you through the mortgage basics and the not-so-basics to determine the best option for you.',
  '22050.features.count': 4,
  '22050.features.1':
    '<b>Wide selection of solutions</b> to meet your specific needs such as First Time Home Buyer, Conventional, Construction, VA, FHA and USDA',
  '22050.features.2':
    '<b>Down Payment and Closing Cost Assistance Programs</b> available, including First@Home with as low as 1% down and Home100 for qualified borrowers',
  '22050.features.3':
    '<b>Pre-qualifications and Pre-approvals</b> make you a more desirable buyer',
  '22050.features.4':
    'Fixed and adjustable rates available ',
  '22050.url': 'https://www.fcbanking.com/personal/mortgages/',
  '22050.cta.1': 'http://mymortgage.fcbanking.com/',
  '22050.disclosures.count': 0,

  '22051.name': 'Home Equity Loans and Lines',
  '22051.description':
    'A home equity loan or line of credit is secured by your home. It’s a great way to use the equity you’ve built up to help you borrow.',
  '22051.description.abbreviated':
    'A home equity loan or line of credit is secured by your home. It’s a great way to use the equity you’ve built up to help you borrow.',
  '22051.features.count': 1,
  '22051.features.1':
    'A home equity loan has a <feature_rates>fixed rate</feature_rates> term and payment, and you receive the entire amount requested as a lump sum. <br /> <br /> A home equity line of credit has a <feature_rates>variable rate</feature_rates> and you will only make payments on the amount you use (or “draw”) from your line.  You will have access to borrow a portion of the amount now or at any time during the term of your line.',
  '22051.url': 'https://www.fcbanking.com/personal/loans/home-equity-loans/',
  '22051.cta.1': 'https://fcbanking.loanspq.com/he/HomeEquityLoan.aspx?lenderref=FCB_120419',
  '22051.disclosures.count': 0,
  '22051.features.column.name': 'Home Equity Loans',
  '22051.features.row.count': 5,
  '22051.features.row.content.1': '$10,000 - $500,000',
  '22051.features.row.content.2': '5 to 20 years',
  '22051.features.row.content.3': 'Up to 80%',
  '22051.features.row.content.4': 'First or second lien',
  '22051.features.row.content.5': '<ul><li><b>Save money</b> with a rate discount when you select automatic payments from your FCB <feature_checking>checking account</feature_checking></li><li>Conveniently view balance and transactions in mobile/ online banking</li></ul>',


  '22052.name': 'Home Equity Lines',
  '22052.description':
    'A home equity line of credit uses the equity you’ve built in your home to help you borrow as you need.  You will have access to borrow a portion of the amount now or at any time during the term of your line.  Your line will have a variable rate and you will only make payments on the amount you use (or “draw”) from your line.',
  '22052.description.abbreviated':
    'A home equity line of credit uses the equity you’ve built in your home to help you borrow as you need.  You will have access to borrow a portion of the amount now or at any time during the term of your line.  Your line will have a variable rate and you will only make payments on the amount you use (or “draw”) from your line.',
  '22052.features.count': 6,
  '22052.features.1': 'No closing costs or processing fees',
  '22052.features.2': 'Available for credit lines from $10,000 to $500,000',
  '22052.features.3':
    'A fixed interest rate lock payment option allows you to convert a portion of your balance to a fixed interest rate for a term of 3 to 20 years',
  '22052.features.4':
    'Borrow up to 85% of your home equity as a first or second lien',
  '22052.features.5':
    'Access your funds by check, phone, online, or at a First Commonwealth office',
  '22052.features.6':
    'Set up automatic payments from your First Commonwealth checking account',
  '22052.url':
    'https://www.fcbanking.com/personal/loans/home-equity-lines-of-credit/',
  '22052.cta.1':
    'https://fcbanking.loanspq.com/he/HomeEquityLoan.aspx?lenderref=FCB_120419',
  '22052.disclosures.count': 0,
  '22052.features.column.name': 'Home Equity Lines',
  '22052.features.row.count': 5,
  '22052.features.row.content.1': '$10,000 - $500,000',
  '22052.features.row.content.2': '10 year draw period',
  '22052.features.row.content.3': 'Up to 89%',
  '22052.features.row.content.4': 'First or second lien',
  '22052.features.row.content.5': '<ul><li>A fixed interest rate lock payment option allows you to convert a portion of your balance to a fixed interest rate for a term of 3 to 20 years</li><li><b>Conveniently view balance and transactions</b> in mobile/ online banking</li><li><b>Manage your money</b> from anywhere with access to your funds by check, phone, online or at a <feature_locations>First Commonwealth office</feature_locations></li><li><b>Peace of mind</b> when you set up automatic payments from your FCB <feature_checking>checking account</feature_checking> so you never miss a payment</li></ul>',

  '22053.name': 'Personal Loan',
  '22053.description':
    "Personal loans that don't require collateral (like a home) are sometimes just what you need to continue on your financial journey.",
  '22053.description.abbreviated':
    "Personal loans that don't require collateral (like a home) are sometimes just what you need to continue on your financial journey.",
  '22053.features.count': 2,
  '22053.features.1':
    '<b>Flexibility to</b> <feature_rates><b>choose</b> from fixed or variable interest rates</feature_rates> and terms from 1 to 5 years',
  '22053.features.2':
    '<b>Save money</b> with a rate discount with automatic payments from your <feature_checking>FCB checking account</feature_checking>, making it easier for you to manage your monthly budget and never miss a payment.',
  '22053.url': 'https://www.fcbanking.com/personal/loans/personal-loans/',
  '22053.cta.1': 'https://fcbanking.loanspq.com/pl/PersonalLoan.aspx?lenderref=FCB_120419',
  '22053.disclosures.count': 0,

  '22054.name': 'Personal Access Line of Credit',
  '22054.description':
    "Personal access lines of credit that don't require collateral (like a home) are sometimes just what you need to continue on your financial journey.",
  '22054.description.abbreviated':
    "Personal access lines of credit that don't require collateral (like a home) are sometimes just what you need to continue on your financial journey.",
  '22054.features.count': 2,
  '22054.features.1':
    '<b>Manage your money</b> from anywhere with access to your funds by check, phone, online, or at a <feature_locations>First Commonwealth office</feature_locations>',
  '22054.features.2':
    '<b>Peace of mind</b> with options to help manage your budget' +
    '<ul>' +
    '    <li>Set up automatic payments from your FCB <feature_checking>checking account</feature_checking> so you never miss a payment </li>' +
    '    <li>Link your line to your <feature_checking>FCB checking account</feature_checking> for <feature_overdraft>overdraft protection</feature_overdraft>; we’ll transfer available funds to cover the difference if you happen to overdraw </li>' + '    <li>Available for credit lines from $1,000 to $25,000</li>' +
    '    <li><feature_rates>Rates</feature_rates> are based on the Wall Street Journal Prime Rate</li>' +
    '</ul>',
  '22054.url': 'https://www.fcbanking.com/personal/loans/personal-loans/',
  '22054.cta.1': 'https://fcbanking.loanspq.com/pl/PersonalLoan.aspx?lenderref=FCB_120419',
  '22054.disclosures.count': 0,

  '22055.name': 'Auto Loan',
  '22055.description':
    'We make finding the right car loan a whole lot easier. Whether you’re looking for the car loan rates for a new or used car, we offer loans for both.',
  '22055.description.abbreviated':
    'We make finding the right car loan a whole lot easier. Whether you’re looking for the car loan rates for a new or used car, we offer loans for both.',
  '22055.features.count': 2,
  '22055.features.1':
    '<b>Save money</b> with a rate discount with automatic payments from your FCB <feature_checking>checking account</feature_checking>, making it easier for you to manage your monthly budget and never miss a payment',
  '22055.features.2':
    '<b>Peace of mind</b> knowing you’re able to make additional payments to your principal without penalty. This is a great way to pay off your debt faster allowing you to move what you were paying on your loan into savings or to help pay off other debt',
  '22055.url': 'https://www.fcbanking.com/personal/loans/auto-loans/',
  '22055.disclosures.count': 0,

  '22056.name': 'Home Equity Loan and Lines',
  '22056.description':
    'A home equity loan or line of credit is secured by your home. It’s a great way to use the equity you’ve built up to help you borrow. <br /><br /> A home equity loan has a <feature_rates>fixed rate</feature_rates> term and payment, and you receive the entire amount requested as a lump sum. <br /><br /> A home equity line of credit has a <feature_rates>variable rate</feature_rates> and you will only make payments on the amount you use (or “draw”) from your line.  You will have access to borrow a portion of the amount now or at any time during the term of your line.',
  '22056.description.abbreviated':
    'A home equity loan or line of credit is secured by your home. It’s a great way to use the equity you’ve built up to help you borrow. <br /><br /> A home equity loan has a <feature_rates>fixed rate</feature_rates> term and payment, and you receive the entire amount requested as a lump sum. <br /><br /> A home equity line of credit has a <feature_rates>variable rate</feature_rates> and you will only make payments on the amount you use (or “draw”) from your line.  You will have access to borrow a portion of the amount now or at any time during the term of your line.',
  '22056.features.columns.count': 3,
  '22056.features.columns': ['22056','22051', '22052'],
  '22056.url':
    'https://www.fcbanking.com/personal/loans/home-equity-loans/',
  '22056.cta.1':
    'https://www.fcbanking.com/personal/loans/home-equity-lines-of-credit/',
  '22056.disclosures.count': 0,

  '22056.features.column.name': 'Feature',
  '22056.features.row.count': 5,
  '22056.features.row.content.1': 'Amounts available',
  '22056.features.row.content.2': 'Terms available',
  '22056.features.row.content.3': 'Loan to value',
  '22056.features.row.content.4': 'Lien position',
  '22056.features.row.content.5': 'Additional features',

  '22057.name': 'VA Home Loan',
  '22057.description':
    'Qualified veterans and active-duty military personnel can use this loan program for purchasing and refinancing a home.',
  '22057.description.abbreviated':
    'Qualified veterans and active-duty military personnel can use this loan program for purchasing and refinancing a home.',
  '22057.features.count': 6,
  '22057.features.1':
    '<b>No down payment</b> required',
  '22057.features.2':
    '<b>Up to 100% financing</b> for eligible service members and veterans',
  '22057.features.3':
    '<b>Insured by the Veteran\'s Administration</b>',
  '22057.features.4':
    '<b>Competitive rates and closing costs</b>',
  '22057.features.5':
    '<b>No monthly mortgage insurance payment</b>',
  '22057.features.6':
    '<b>Funding Fee is financed in the loan amount</b>, and some veterans are exempt from paying the funding fee',
  '22057.url':
    'https://www.fcbanking.com/personal/loans/home-equity-loans/',
  '22057.cta.1':
    'https://www.fcbanking.com/personal/loans/home-equity-lines-of-credit/',
  '22057.disclosures.count': 0,

  '22060.name': 'Homeowners Insurance',
  '22060.description':
    'First Commonwealth Insurance Agency has access to an extensive list of the most highly rated insurance carriers available in the market.  Our professionals are available to quickly review the appropriateness of your coverages and costs to ensure your assets are properly protected at the most competitive premiums.',
  '22060.description.abbreviated':
    'First Commonwealth Insurance Agency has access to an extensive list of the most highly rated insurance carriers available in the market.  Our professionals are available to quickly review the appropriateness of your coverages and costs to ensure your assets are properly protected at the most competitive premiums.',
  '22060.features.count': 1,
  '22060.features.1':  '' +
    'While none of us expect theft or damage, you can be prepared to face a challenge with the right home insurance.  Our coverage plans include:' +
  '<ul>' +
  '    <li>Homeowners, Condo, Renter</li>' +
  '    <li>Dwelling Fire/ Secondary Residence</li>' +
  '    <li>Flood Insurance</li>' +
  '    <li>Mine Subsidence</li>' +
  '    <li>New Home Construction</li>' +
  '    <li>Personal Articles</li>' +
  '    <li>Personal Umbrella Coverage</li>' +
  '</ul>',
  '22060.url': 'https://www.fcbanking.com/personal/insurance/',
  '22060.cta.1': 'https://fcbanking.castlecustomerconnect.com/',
  '22060.disclosures.count': 0,

  '22061.name': 'Auto Insurance',
  '22061.description':
    'First Commonwealth Insurance Agency has access to an extensive list of the most highly rated insurance carriers available in the market.  Our professionals are available to quickly review the appropriateness of your coverages and costs to ensure your assets are properly protected at the most competitive premiums.',
  '22061.description.abbreviated':
    'First Commonwealth Insurance Agency has access to an extensive list of the most highly rated insurance carriers available in the market.  Our professionals are available to quickly review the appropriateness of your coverages and costs to ensure your assets are properly protected at the most competitive premiums.',
  '22061.features.count': 1,
  '22061.features.1':
    'Our car insurance plans include:' +
    '<ul>' +
    '  <li>Private Passenger</li>' +
    '  <li>Classic Cars</li>' +
    '  <li>Boats</li>' +
    '  <li>ATV/UTV (Utility Terrain Vehicles)</li>' +
    '</ul>',
  '22061.url': 'https://www.fcbanking.com/personal/insurance/',
  '22061.cta.1': 'https://fcbanking.castlecustomerconnect.com/',
  '22061.disclosures.count': 0,

  '22062.name': 'Life Insurance',
  '22062.description':
    'Life Insurance can help protect your family, build a legacy and potentially save on taxes.  Long term care and disability insurance are additional options for protecting your assets against illnesses or injuries.',
  '22062.description.abbreviated':
    'Life Insurance can help protect your family, build a legacy and potentially save on taxes.  Long term care and disability insurance are additional options for protecting your assets against illnesses or injuries.',
  '22062.features.count': 4,
  '22062.features.1':
    'Get your questions answered and personal guidance from a financial professional',
  '22062.features.2':
    'Determine the right type and amount of coverage for you and your family',
  '22062.features.3': 'Decide what to do with old policies',
  '22062.features.4': 'See how insurance fits into your overall financial plan',
  '22062.url':
    'https://www.fcbanking.com/personal/investment-brokerage-services/insurance/',
  '22062.cta.1':
    'https://fcbanking.castlecustomerconnect.com/',
  '22062.disclosures.count': 0,

  '22070.name': 'Mobile Wallet',
  '22070.description': 'Say goodbye to your bulky wallet by making it digital.',
  '22070.description.abbreviated':
    'Say goodbye to your bulky wallet by making it digital.',
  '22070.features.count': 3,
  '22070.features.1':
    'Add your debit card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup>, Samsung Pay<sup>TM</sup>, Fitbit Pay<sup>TM</sup> or Garmin Pay<sup>TM</sup> for a faster checkout',
  '22070.features.2':
    'Card numbers are not stored on your device and are never shared with the merchant',
  '22070.features.3':
    'Transactions are monitored using the same security that protects your card',
  '22070.url':
    'https://www.fcbanking.com/personal/online-banking-services/mobile-wallet/',
  '22070.disclosures.count': 0,

  '22072.name': 'Mobile and Online Banking',
  '22072.description':
    'Manage your money anywhere, anytime from any device.',
  '22072.description.abbreviated':
    'Manage your money anywhere, anytime from any device.',
  '22072.features.count': 3,
  '22072.features.1':
    'Manage your money from anywhere' +
    '<ul>' +
    '  <li><b>Deposit checks</b> using the camera on your phone</li>' +
    '  <li><b>Pay bills</b> without ever needing a stamp or writing a check</li>' +
    '  <li><b>Zelle<sup>®</sup></b> makes it easy to send money directly from your account to people you know and trust</li>' +
    '  <li><b>Connect</b> with a team member when you have a question about your account</li>' +
    '</ul>',
  '22072.features.2':
    'Access tools to help build your financial confidence' +
    '<ul>' +
    '  <li><b>Credit Score Manager</b> will help you better understand your credit standing and track changes </li>' +
    '  <li><b>Money Manager</b> is a one-stop location to view all of your accounts including those at other financial institutions, set savings goals, establish a budget and more</li>' +
    '  <li><b>Customized account alerts</b> can be set up to alert you if your balance dips below your comfort zone </li>' +
    '</ul>',
  '22072.features.3':
    'Keep your banking secure' +
    '<ul>' +
    '  <li>Face ID or Touch ID (depending on your device) allows you to log in to mobile banking easily and securely</li>' +
    '  <li><b>2 factor authentication</b> is used anytime you log in on a new device</li>' +
    '</ul>',
  '22072.url':
    'https://www.fcbanking.com/personal/online-banking-services/mobile-banking-app/ ',
  '22072.disclosures.count': 0,

  '22073.name': 'Debit Card',
  '22073.description':
    'Bank and buy with security and confidence.',
  '22073.description.abbreviated':
    'Bank and buy with security and confidence.',
  '22073.features.count': 2,
  '22073.features.1':
    '<b>Faster and more secure ways to pay</b>' +
    '<ul>' +
    '  <li>Tap & go<sup>®</sup> at checkout with our <feature_1_22073>contactless technology</feature_1_22073></li>' +
    '  <li>Use Click to Pay to make online purchases quicker and more secure </li>' +
    '  <li>Add your card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup>, Samsung Pay<sup>TM</sup>, or Garmin Pay<sup>TM</sup></li>' +
    '</ul>',
  '22073.features.2':
    '<b>Protect your wallet against fraud</b>' +
    '<ul>' +
    '  <li>Lock and unlock your debit card with <feature_1_22073>SecurLOCK<sup>TM</sup> Equip</feature_1_22073></li>' +
    '  <li>Free Mastercard<sup>®</sup> Identity Protection when you enroll your card</li>' +
    '</ul>',
  '22073.url':
    'https://www.fcbanking.com/personal/checking-accounts/debit-cards/',
  '22073.disclosures.count': 0,

  '22090.name': 'Secured Card',
  '22090.description': 'If you are looking to build, or re-build, your credit, a Secured Card is a great place to start. On-time payments to your card can help move your credit score in the right direction.',
  '22090.description.abbreviated': 'If you are looking to build, or re-build, your credit, a Secured Card is a great place to start. On-time payments to your card can help move your credit score in the right direction.',
  '22090.features.count': 5,
  '22090.features.1':
      '<b>Peace of mind</b> knowing you can re-build or establish credit with responsible use',
  '22090.features.2':
      '<b>Save money</b> with no fees for balance transfers for 3 months from account opening',
  '22090.features.3':
    '<b>Faster and more secure ways to pay</b>' +
    '<ul>' +
    '  <li>Tap & go<sup>®</sup> at checkout with our contactless technology</li>' +
    '  <li>Use Click to Pay to make online purchases quicker and more secure </li>' +
    '  <li>Add your card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup> and Samsung Pay<sup>TM</sup></li>' +
    '</ul>',
  '22090.features.4':
    '<b>Protect your wallet against fraud</b>' +
    '<ul>' +
    '  <li>Lock and unlock your card in mobile/ online banking</li>' +
    '  <li>Free Mastercard<sup>®</sup> Identity Protection when you enroll your card</li>' +
    '</ul>',
  '22090.features.5':
      'Credit limits of $300 to $5,000 with corresponding deposit into a savings',
  '22090.url': 'https://www.fcbanking.com/personal/credit-cards/',
  '22090.cta.1': 'https://fcbanking.loanspq.com/cc/CreditCard.aspx?lenderref=FCB_120419',
  '22090.disclosures.count': 0,

  '22091.name': 'Student Card',
  '22091.description':
    'Students of all ages deserve a rewards card, that’s why we offer a Student Credit Card with rewards. If you are a student, full or part time, this is the right card for you.',
  '22091.description.abbreviated':
    'Students of all ages deserve a rewards card, that’s why we offer a Student Credit Card with rewards. If you are a student, full or part time, this is the right card for you.',
  '22091.features.count': 7,
  '22091.features.1':
      'For all students, whether full or part time',
  '22091.features.2':
      'No annual fee',
  '22091.features.3':
      '<b>Earn money</b> with 1% rewards on your everyday purchases, which are automatically credited to your account each quarter in $20 increments',
  '22091.features.4':
      '<b>Save money</b> with our 0% introductory APR on purchases and balance transfers for 6 months, no balance transfer fee for 3 months from account opening',
  '22091.features.5':
    '<b>Faster and more secure ways to pay</b>' +
    '<ul>' +
    '  <li>Tap & go<sup>®</sup> at checkout with our contactless technology</li>' +
    '  <li>Use Click to Pay to make online purchases quicker and more secure </li>' +
    '  <li>Add your card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup> and Samsung Pay<sup>TM</sup></li>' +
    '</ul>',
  '22091.features.6':
    '<b>Protect your wallet against fraud</b>' +
    '<ul>' +
    '  <li>Lock and unlock your card in mobile/ online banking</li>' +
    '  <li>Free Mastercard<sup>®</sup> Identity Protection when you enroll your card</li>' +
    '</ul>',
  '22091.features.7':
    'Credit limits range from $300 to $5,000',
  '22091.url': 'https://www.fcbanking.com/personal/credit-cards/',
  '22091.cta.1': 'https://fcbanking.loanspq.com/cc/CreditCard.aspx?lenderref=FCB_120419',
  '22091.disclosures.count': 0,

  '22092.name': 'Rewards Card',
  '22092.description':
    'Earn rewards on your everyday spending.',
  '22092.description.abbreviated':
    'Earn rewards on your everyday spending.',
  '22092.features.count': 5,
  '22092.features.1':
    '<b>Earn money</b> with 1% rewards on your everyday purchases, which are automatically credited to your account each quarter in $50 increments',
  '22092.features.2':
    '<b>Save money</b> with our 0% introductory APR on purchases and balance transfers for 6 months, no balance transfer fee for 3 months from account opening',
  '22092.features.3':
    '<b>Faster and more secure ways to pay</b>' +
    '<ul>' +
    '  <li>Tap & go<sup>®</sup> at checkout with our contactless technology</li>' +
    '  <li>Use Click to Pay to make online purchases quicker and more secure </li>' +
    '  <li>Add your card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup>, or Samsung Pay<sup>TM</sup></li>' +
    '</ul>',
  '22092.features.4':
    '<b>Protect your wallet against fraud</b>' +
    '<ul>' +
    '  <li>Lock and unlock your card in mobile/ online banking</li>' +
    '  <li>Free Mastercard<sup>®</sup> Identity Protection when you enroll your card</li>' +
    '</ul>',
  '22092.features.5':
    'Credit limits range from $1,000 to $25,000',
  '22092.url': 'https://www.fcbanking.com/personal/credit-cards/',
  '22092.cta.1': 'https://fcbanking.loanspq.com/cc/CreditCard.aspx?lenderref=FCB_120419',
  '22092.disclosures.count': 0,

  '22093.name': 'Refer A Friend',
  '22093.description': 'Earn up to $500 a year for referring friends and family to bank with us.<sup>1</sup>',
  '22093.description.abbreviated': 'Earn up to $500 a year for referring friends and family to bank with us.<sup>1</sup>',
  '22093.features.count': 3,
  '22093.features.1':
      'Get a $50 Mastercard<sup>®</sup> Reward Card when friends and family you refer open and use a First Commonwealth Bank checking account<sup>1</sup>',
  '22093.features.2':
      'Your friend can also earn a Mastercard<sup>®</sup> Reward Card – $50 for a personal checking account and $150 for a business checking account',
  '22093.features.3':
      'Register and make referrals at <features_3_22093>fcbanking.com/referafriend</features_3_22093>, from your online banking account, or at your <feature_locations>local First Commonwealth office</feature_locations>',
  '22093.url': 'https://www.fcbanking.com/personal/refer-a-friend/',
  '22093.cta.1': 'https://www.fcbanking.com/personal/refer-a-friend/',
  '22093.disclosures.count': 1,
  '22093.disclosures.1': '<sup>1</sup>Terms and conditions apply and are available at <disclosures_1_22093>www.fcbanking.com/referafriend</disclosures_1_22093> or by clicking <em>Learn More</em> above.',

  '22094.name': 'Business Solutions',
  '22094.description': 'We love partnering with our business customers. Together, we can help you manage your business finances by providing you with the tools and resources needed to ensure success on your financial journey.',
  '22094.description.abbreviated': 'We love partnering with our business customers. Together, we can help you manage your business finances by providing you with the tools and resources needed to ensure success on your financial journey.',
  '22094.features.count': 8,
  '22094.features.1':
      '<b>Checking</b> - Whether you’re just starting out, or you need an account that accommodates high transaction volume, we have the perfect solution for your business.',
  '22094.features.2':
      '<b>Savings</b> - Our savings accounts will help you make the most of your excess cash flows and allow you to save with intention while maintaining access to your money.',
  '22094.features.3':
      '<b>Treasury Management</b> - We have tools to help you manage your receivables, disbursements and payments, optimize your cash flow effectively, and protect you from payment fraud.',
  '22094.features.4':
      '<b>Merchant Services</b> - We’ve teamed up with Heartland to offer you innovative payment and point of sale solutions to help you run your business more effectively and help you make it easy for your customers to do business with you.',
  '22094.features.5':
      '<b>Business Loans</b> - Whether for inventory, purchasing, expansion, real estate, or any other need that may arise, all businesses occasionally require financing. We have a diverse array of business loan options including SBA, tailored to your specific need.',
  '22094.features.6':
      '<b>Company Credit Card</b> - Enjoy the convenience of paying for your business expenses such as meals, travel, customer entertainment and everyday purchases in a controlled environment, all while earning 1% cash back on your purchases.',
  '22094.features.7':
      '<b>Employee Benefits Solutions</b> - Our Insurance Agency can help you protect your employees and achieve optimal outcomes, including comprehensive risk management, reduced healthcare trends and total cost savings and stability.',
  '22094.features.8':
      '<b>Wealth Management</b> - We will work closely with you to understand your unique financial needs. From wealth planning services, including business succession planning to risk management, we have a rich history of creating customized solutions and strategies that build financial confidence.',
  '22094.url': 'https://www.fcbanking.com/business/',
  '22094.disclosures.count': 0,
};
